import { useState, useContext } from "react";
import { Layout, ConfigProvider, theme as antdTheme } from "antd";
import AdminSidebar from "./AdminSidebar";
import { Outlet } from "react-router-dom";
import "./AdminLayout.css";
import { ThemeContext } from "../../context/ThemeContext";
import ModernHeader from "../ModernHeader";

const { Content, Header } = Layout;

const AdminLayout = () => {
  const { isDark } = useContext(ThemeContext);
  const [collapsed, setCollapsed] = useState(false);
  const handleToggleSidebar = () => setCollapsed((prev) => !prev);
  return (
    <div
      className="admin-theme-root"
      data-admin-theme={isDark ? "dark" : "light"}
    >
      <ConfigProvider
        theme={{
          algorithm: isDark
            ? antdTheme.darkAlgorithm
            : antdTheme.defaultAlgorithm,
        }}
      >
        <>
          <AdminSidebar collapsed={collapsed} />
          <Layout
            className="admin-layout"
            style={{ marginLeft: collapsed ? 80 : 220 }}
          >
            <Layout className="admin-main-layout">
              <ModernHeader
                title="Admin Panel"
                collapsed={collapsed}
                onToggleSidebar={handleToggleSidebar}
              />
              <Content className="admin-content">
                <div className="admin-content-wrapper">
                  <Outlet />
                </div>
              </Content>
            </Layout>
          </Layout>
        </>
      </ConfigProvider>
    </div>
  );
};

export default AdminLayout;
